// drag and resize
import {createAction} from 'util/redux';
import {ModalKey} from 'module/Modal/type/ModalKey';
import {ModalPosition, ModalSize} from 'module/Modal/reducer/ModalType';

const NAMESPACE = 'MODAL/'
export const modalSetPosSizeAction = createAction<{ modalKey: ModalKey, position?: ModalPosition, size?: ModalSize }>(NAMESPACE + 'setPosSize')
export const toggleModalAction = createAction<{ modalKey: ModalKey, open: boolean }>(NAMESPACE + 'toggle')
export const fullScreenModalAction = createAction<{ modalKey: ModalKey, fullScreen: boolean }>(NAMESPACE + 'fullScreen')
export const modalKeyValueChangedAction = createAction<{
	modalKey: ModalKey,
	key: string,
	value?: string | number | boolean
}>(NAMESPACE + 'KeyValueChanged')